import React, {useState, useContext, useEffect} from 'react'; 
import { postEditPost } from '../../../utils/api/functions/advancedActivityFeeds';
import { Button, Modal } from 'react-bootstrap';
import { toast } from 'react-toastify';
import { FeedContext } from '../../../utils/context/feedContext';
import RicherTextArea from '../../../utils/RicherTextArea/RicherTextArea';

const EditPostModal = ({ postId, showModal, handleClose }) => {
    const { handleEditPost, posts } = useContext(FeedContext);
    const [postContent, setPostContent] = useState("");

    const handleSave = async() => {
        try {
            console.log("Editing post id: ", postId);
            await handleEditPost(postId, postContent);
        } catch (error) {
            toast.error('Error updating post');
        }
    }
    const handleChange = (text) => {
        setPostContent(text);
    }

    useEffect(() => {
        if(!!postId) {
            const post = posts.find(p => p.feed.action_id === postId);
            if(post) setPostContent(post.feed.body);
        }
    }, [postId])

    return(
        <Modal show={showModal} onHide={handleClose} size="lg" centered>
            <Modal.Header closeButton>
                <Modal.Title>Edit Post</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                {
                    postContent ? <RicherTextArea onChange={handleChange} initialValue={postContent} /> : null
                }
            </Modal.Body>

            <Modal.Footer>
                <div style={{
                    display: "flex", 
                    justifyContent: "space-evenly",
                    width: "100%"
                }}>
                    <Button onClick={handleClose} variant="danger">Cancel</Button>
                    <Button onClick={handleSave} variant="primary">Save</Button>
                </div>
            </Modal.Footer>
        </Modal>
    )
}


export default EditPostModal; 